import { useMutation } from '@apollo/client'
import { useState } from 'react'
import toast from 'react-hot-toast'

import Button, { ButtonIntents } from 'shared/ui/Button'
import Flex from 'shared/ui/Flex'
import Input from 'shared/ui/Input'
import IslandModal from 'shared/components/modals/IslandModal'
import { REMOVE_NON_MATCHING_PAGES_META } from 'data/layoutcreator/mutations/admin'

type RemoveNonMatchingPagesMetaModalProps = {
  isOpen: boolean
  closeModal: () => void
}

const RemoveNonMatchingPagesMetaModal: React.FC<RemoveNonMatchingPagesMetaModalProps> = ({
  isOpen,
  closeModal,
}) => {
  const [projectId, setProjectId] = useState('')

  const [removeNonMatchingPagesMeta] = useMutation(REMOVE_NON_MATCHING_PAGES_META)

  const handleSubmit = async () => {
    const toastId = toast.loading('Removing non-matching pages meta...')

    const { data, errors } = await removeNonMatchingPagesMeta({
      variables: {
        projectId
      }
    })

    toast.dismiss(toastId)

    if (errors) {
      toast.error('Failed to remove non-matching pages meta 😬')
      return
    } else if (data) {
      toast.success(`Successfully removed ${data.removeNonMatchingPagesMeta} non-matching pages 👌`)
      closeModal()
    }
  }

  return (
    <IslandModal
      isOpen={isOpen}
      closeModal={closeModal}
      width={600}
      title="Remove non-matching pages meta"
    >
      <Flex direction="column">
        <Flex direction="column" rowGap={16}>
          <Input value={projectId} onChange={setProjectId} label="Project ID" />
        </Flex>

        <Flex marginTop={46}>
          <Button
            intent={ButtonIntents.dark}
            labelId="Admin.buttons.submit"
            borderRadius={100}
            isFullWidth
            isDisabled={!projectId}
            onClick={handleSubmit}
          />
        </Flex>
      </Flex>
    </IslandModal>
  )
}

export default RemoveNonMatchingPagesMetaModal 